import { RiStickyNoteLine } from "@itandi/itandi-bb-ui";
import { Box } from "@itandi/itandi-bb-ui/Box";
import { Label } from "@itandi/itandi-bb-ui/Label";
import { AccordionHtml } from "~/components/common/accordion_html/AccordionHtml";
import { useDealVendorNoteContext } from "~/components/common/deals/show/vendor_card/DealVendorNoteProvider";
import { EditMenuButton } from "~/components/common/parts/button/EditMenuButton";
import { displayUpdateUserName } from "~/models/DealVendorNote";
import Styles from "../DealCard.module.scss";

/**
 * 共有案件メモCard
 * @for vendor
 */
export function DealVendorNoteCard() {
	const { dealVendorNote, handleOpen, isReady } = useDealVendorNoteContext();
	const updateUserName = dealVendorNote
		? displayUpdateUserName(dealVendorNote)
		: "";

	return isReady ? (
		<Box>
			<div className={Styles.DealCard}>
				<h3 className={Styles.Title}>
					<div>
						<div>
							<RiStickyNoteLine className={Styles.TitleIcon} />
							共有案件メモ（施工会社入力）
						</div>
						{dealVendorNote !== null && (
							<div className={Styles.UpdateUser}>
								<Label size="xs">{`最終更新者 : ${updateUserName}`}</Label>
							</div>
						)}
					</div>
					<div className={Styles.EditButtonWrapper}>
						<EditMenuButton onClick={handleOpen}>変更</EditMenuButton>
					</div>
				</h3>
				<div className={Styles.Content}>
					{dealVendorNote === null ? (
						<span className={Styles.NotYet}>未入力</span>
					) : (
						<AccordionHtml
							html={dealVendorNote.noteHtml}
							maxHeightForClosed={170}
						/>
					)}
				</div>
			</div>
		</Box>
	) : null;
}
